import { Theme, ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

export const listItemStaticStyles = {
  fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall
};

export const getListItemStyles = (theme: Theme) => ({
  ...listItemStaticStyles,
  color: theme.palette.text.primary
});

export const MuiListItem: ThemeOptions['components']['MuiListItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...getListItemStyles(theme)
    })
  }
};
